export enum MessageType {
    Standard = 0,
    StandardWithFiles = 1,
    RequestRevision = 2,
    RequestApproval = 3,
    CancelRequestRevision = 4,
    DoctorRating = 5,
    AIProcessFailed = 6,
    RequestRefund = 7,
    RevisionFeeAssessed = 8,
    RevisionFeeApproved = 9,
    RevisionFeeRejected = 10,
    RevisionFeeAssessedWithFiles = 11,
    AIRequestRevision = 12,
    PrintAndShipOrderReceived = 13,
    TrackingLinkReceived = 14,
}
